import { useTranslation } from 'react-i18next';
import { IconLocation, ImageLocation, ScenariosLocation } from 'src/utils/URLUtils';
import styles from './LessonsFirstVisit.module.scss';

export default function LessonsFirstVisit() {
    const { t } = useTranslation();
    return (
        <>
            <section className={styles.lessonsItem} >
                <div className={styles.lessonsItemContent}>
                    <div className={styles.lessonsItemImageWrapper}>
                        <img className={styles.lessonsItemImage}
                            src={ScenariosLocation(`bagr`)}
                            alt='lesson' />
                    </div>
                    <div className={styles.lessonsItemContentText}>
                        <h2>{t('Greetings')}</h2>
                        <p>{
                            t('Completed') + ' ' + 0 + ' ' + t('of') + ' ' + 10}</p>
                    </div>

                </div>
                <div className={styles.lessonsItemContentButton}>
                    <img src={IconLocation('chevron-right')} alt="Button" />
                </div>
            </section >
            <div className={`${styles.lessonsFirstVisit} guideModal`}>
                <img src={ImageLocation('Lexi/smile.png')} alt="lexi" className='lexiIcon' />
                <p className={styles.guideText}>{t('Pick a topic and practice asking questions and answering them.')}</p>
            </div>
        </>
    );
} 